(() => {
  const roots=document.querySelectorAll('[data-bat-hbx-search]');
  if(!roots.length)return;
  const money=(v,c)=>{const n=Number(v);if(!Number.isFinite(n))return v||'';try{return new Intl.NumberFormat(undefined,{style:'currency',currency:c||'EUR'}).format(n)}catch{return(c||'')+' '+n.toFixed(2)}};
  const iso=d=>d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
  const el=(t,c,x)=>{const n=document.createElement(t);if(c)n.className=c;if(x!==undefined)n.textContent=x;return n};
  const addImage=(p,u,a,c='',fallback='')=>{if(!u&&!fallback)return null;const i=el('img',c);i.alt=a||'';const roomMedia=!!(p&&p.classList&&(p.classList.contains('bat-hbx-room-thumb')||p.classList.contains('bat-hbx-room-media')));i.loading=roomMedia?'eager':'lazy';i.decoding=roomMedia?'sync':'async';if(roomMedia){try{i.fetchPriority='high'}catch{}}const primary=roomMedia&&fallback?fallback:(u||fallback);const secondary=primary===u?fallback:u;let triedFallback=false;i.addEventListener('error',()=>{if(secondary&&!triedFallback&&secondary!==primary){triedFallback=true;i.src=secondary;return}i.remove();if(p&&p.classList&&p.classList.contains('bat-hbx-gallery')&&!p.querySelector('img'))p.remove()});i.src=primary;p.appendChild(i);return i};

  const cancellationSummary=rate=>{
    const policies=Array.isArray(rate?.cancellationPolicies)?rate.cancellationPolicies:[];
    if(String(rate?.rateClass||'').toUpperCase()==='NRF')return {label:'Non-refundable',policies};
    if(policies.length)return {label:'Cancellation policy available',policies};
    return {label:'Flexible / standard',policies:[]};
  };

  const BOARD_LABELS={RO:'Room only',BB:'Breakfast included',HB:'Half board',FB:'Full board',AI:'All inclusive',SC:'Self catering'};
  const boardLabel=rate=>{
    const code=String(rate?.boardCode||'').trim().toUpperCase();
    if(BOARD_LABELS[code])return BOARD_LABELS[code];
    const raw=String(rate?.boardName||'').trim();
    if(!raw)return 'Room rate';
    if(/^BED AND BREAKFAST$/i.test(raw))return 'Breakfast included';
    return raw.toLowerCase().replace(/\b\w/g,m=>m.toUpperCase());
  };
  const rateAmount=rate=>{
    const n=Number(rate?.net??rate?.sellingRate);
    return Number.isFinite(n)?n:NaN;
  };
  const policyDate=value=>{
    if(!value)return '';
    const d=new Date(value);
    if(!Number.isFinite(d.getTime()))return String(value);
    try{return new Intl.DateTimeFormat(undefined,{day:'numeric',month:'short',hour:'numeric',minute:'2-digit'}).format(d)}
    catch{return String(value)}
  };
  const visibleRateKey=rate=>{
    const policies=Array.isArray(rate?.cancellationPolicies)?rate.cancellationPolicies:[];
    return [
      String(rate?.boardCode||rate?.boardName||'').trim().toUpperCase(),
      String(rate?.rateClass||'').trim().toUpperCase(),
      Number(rate?.rooms||1),
      Number(rate?.adults||0),
      Number(rate?.children||0),
      policies.map(p=>String(p?.from||'')).join('|')
    ].join('::');
  };
  const customerRates=rates=>{
    const best=new Map();
    (Array.isArray(rates)?rates:[]).forEach(rate=>{
      const key=visibleRateKey(rate);
      const existing=best.get(key);
      const amount=rateAmount(rate);
      const existingAmount=rateAmount(existing);
      if(!existing||(Number.isFinite(amount)&&(!Number.isFinite(existingAmount)||amount<existingAmount)))best.set(key,rate);
    });
    return [...best.values()].sort((a,b)=>{
      const aa=rateAmount(a),bb=rateAmount(b);
      if(!Number.isFinite(aa)&&!Number.isFinite(bb))return 0;
      if(!Number.isFinite(aa))return 1;
      if(!Number.isFinite(bb))return -1;
      return aa-bb;
    });
  };
  const rateInfo=(rate,currency)=>{
    const policies=Array.isArray(rate?.cancellationPolicies)?rate.cancellationPolicies:[];
    const first=policies[0]||{};
    const nrf=String(rate?.rateClass||'').toUpperCase()==='NRF';
    const roomCount=Math.max(1,Number(rate?.rooms||1));
    const adultCount=Math.max(0,Number(rate?.adults||0));
    const childCount=Math.max(0,Number(rate?.children||0));
    const occupancy=[];
    occupancy.push(roomCount+' room'+(roomCount===1?'':'s'));
    if(adultCount)occupancy.push(adultCount+' adult'+(adultCount===1?'':'s'));
    if(childCount)occupancy.push(childCount+' child'+(childCount===1?'':'ren'));
    let cancellation=nrf?'Non-refundable':'Flexible cancellation';
    let policyNote='';
    if(nrf){
      policyNote='No refund after booking';
    }else if(first?.from){
      policyNote='Cancellation charge applies from '+policyDate(first.from);
      if(first?.amount)policyNote+=' · '+money(first.amount,currency);
    }else if(first?.amount){
      policyNote='Cancellation charge '+money(first.amount,currency);
    }else{
      policyNote='Cancellation terms confirmed before booking';
    }
    return {board:boardLabel(rate),cancellation,occupancy:occupancy.join(' · '),policyNote};
  };
  const emitRoomSelected=async(root,hotel,room,rate,currency,content,checkIn,checkOut,adults,base,status)=>{
    const originalImage=(Array.isArray(room?.images)&&room.images[0])||(Array.isArray(content?.roomImages)&&content.roomImages[0])||(Array.isArray(content?.hotelImages)&&content.hotelImages[0])||null;
    const originalRateKey=rate?.rateKey||'';
    if(!originalRateKey){
      root.dispatchEvent(new CustomEvent('bat:checkrate-failed',{bubbles:true,detail:{message:'This rate cannot be checked because HBX did not return a rate key.'}}));
      return;
    }

    root.dispatchEvent(new CustomEvent('bat:checkrate-start',{bubbles:true,detail:{
      hotelName:hotel?.name||content?.name||'Hotel',
      roomName:room?.name||room?.code||'Room'
    }}));
    if(status)status.textContent='Checking the latest room price and cancellation terms with HBX…';

    try{
      const response=await fetch(base+'/_api/hbx/checkrate',{
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({rateKey:originalRateKey})
      });
      const data=await response.json().catch(()=>({}));
      if(!response.ok||!data?.ok){
        const msg=data?.message||data?.error||'HBX could not reconfirm this room rate.';
        throw new Error(msg);
      }

      const result=data?.result||{};
      const checkedHotel=result?.hotel||
        (Array.isArray(result?.hotels)?result.hotels[0]:null)||
        (Array.isArray(result?.hotels?.hotels)?result.hotels.hotels[0]:null)||{};
      const checkedRooms=Array.isArray(checkedHotel?.rooms)?checkedHotel.rooms:
        (Array.isArray(checkedHotel?.rooms?.rooms)?checkedHotel.rooms.rooms:[]);
      const checkedRoom=checkedRooms[0]||{};
      const checkedRates=Array.isArray(checkedRoom?.rates)?checkedRoom.rates:
        (Array.isArray(checkedRoom?.rates?.rates)?checkedRoom.rates.rates:[]);
      const checkedRate=checkedRates[0];
      if(!checkedRate?.rateKey)throw new Error('HBX CheckRate did not return a selectable rate.');

      const cancellation=cancellationSummary(checkedRate);
      const finalCurrency=checkedHotel?.currency||currency||'EUR';
      const detail={
        hotelCode:checkedHotel?.code||hotel?.code||content?.code||'',
        hotelName:checkedHotel?.name||hotel?.name||content?.name||('Hotel '+(hotel?.code||content?.code||'')),
        roomCode:checkedRoom?.code||room?.code||room?.roomCode||'',
        roomName:checkedRoom?.name||room?.name||room?.code||'Room',
        rateKey:checkedRate.rateKey,
        originalRateKey,
        boardName:checkedRate?.boardName||checkedRate?.boardCode||rate?.boardName||rate?.boardCode||'Room rate',
        rateClass:checkedRate?.rateClass||rate?.rateClass||'',
        rateType:checkedRate?.rateType||rate?.rateType||'',
        price:checkedRate?.net||checkedRate?.sellingRate||rate?.net||rate?.sellingRate||'',
        originalPrice:rate?.net||rate?.sellingRate||'',
        currency:finalCurrency,
        cancellationLabel:cancellation.label,
        cancellationPolicies:cancellation.policies,
        checkIn:checkedHotel?.checkIn||checkIn?.value||'',
        checkOut:checkedHotel?.checkOut||checkOut?.value||'',
        adults:checkedRate?.adults||adults?.value||rate?.adults||'',
        children:checkedRate?.children||rate?.children||0,
        imageUrl:originalImage?(originalImage.xlUrl||originalImage.url||''):'',
        imageFallback:originalImage?.url||'',
        checkRateVerified:true,
        checkRateEnvironment:data?.environment||'HBX TEST'
      };
      root.dataset.selectedRateKey=detail.rateKey;
      if(status){
        const changed=String(detail.originalPrice)!==String(detail.price)&&detail.originalPrice&&detail.price;
        status.textContent=changed?'HBX reconfirmed the room with an updated price. Review it before continuing.':'Room and price reconfirmed by HBX CheckRate.';
      }
      root.dispatchEvent(new CustomEvent('bat:room-selected',{bubbles:true,detail}));
    }catch(error){
      const message=error&&error.message?error.message:'HBX CheckRate failed.';
      if(status)status.textContent='Room could not be reconfirmed: '+message;
      root.dispatchEvent(new CustomEvent('bat:checkrate-failed',{bubbles:true,detail:{message}}));
    }
  };

  roots.forEach(root=>{
    if(root.dataset.batHbxReady==='1')return;
    root.dataset.batHbxReady='1';
    const form=root.querySelector('[data-bat-hbx-form]');
    const destinationInput=root.querySelector('[data-bat-hbx-destination]');
    const destinationCode=root.querySelector('[data-bat-hbx-destination-code]');
    const suggestions=root.querySelector('[data-bat-hbx-suggestions]');
    const checkIn=root.querySelector('[data-bat-hbx-checkin]');
    const checkOut=root.querySelector('[data-bat-hbx-checkout]');
    const adults=root.querySelector('[data-bat-hbx-adults]');
    const status=root.querySelector('[data-bat-hbx-status]');
    const results=root.querySelector('[data-bat-hbx-results]');
    const resultsShell=root.querySelector('[data-bat-hbx-results-shell]');
    const mapEl=root.querySelector('[data-bat-hbx-map]');
    const resultTitle=root.querySelector('[data-bat-hbx-result-title]');
    const base=root.dataset.apiBase||'';
    let leafletMap=null, markerLayer=null;
    let hotelDialog=null;
    function ensureHotelDialog(){
      if(hotelDialog&&document.body.contains(hotelDialog))return hotelDialog;
      if(!document.getElementById('bat-hotel-dialog-style')){
        const style=el('style');style.id='bat-hotel-dialog-style';
        style.textContent='.bat-hotel-dialog{width:min(940px,calc(100% - 28px));max-height:90vh;padding:0;border:0;border-radius:22px;background:#fff;color:#1d2f2a;box-shadow:0 28px 90px rgba(0,0,0,.28)}.bat-hotel-dialog::backdrop{background:rgba(13,27,23,.62);backdrop-filter:blur(3px)}.bat-hotel-dialog-card{padding:24px}.bat-hotel-dialog-top{display:flex;align-items:flex-start;justify-content:space-between;gap:18px;margin-bottom:18px}.bat-hotel-dialog-close{border:1px solid #d9ddd9;background:#fff;border-radius:999px;width:40px;height:40px;font-size:22px;line-height:1;cursor:pointer}.bat-hotel-dialog-title{margin:0 0 6px;font-size:clamp(25px,4vw,38px);line-height:1.05}.bat-hotel-dialog-context,.bat-hotel-dialog-meta{color:#60716c;font-size:14px;line-height:1.5}.bat-hotel-dialog-hero{width:100%;max-height:360px;object-fit:cover;border-radius:16px;margin:4px 0 18px}.bat-hotel-dialog-description{color:#41514c;line-height:1.65}.bat-hotel-room-count{display:flex;justify-content:space-between;gap:16px;align-items:end;margin:24px 0 10px}.bat-hotel-room-count h3{margin:0;font-size:22px}.bat-hotel-room-card{border:1px solid #e0e5e2;border-radius:16px;padding:16px;margin:12px 0;background:#fbfcfb}.bat-hotel-room-card h4{margin:0 0 6px;font-size:18px}.bat-hotel-rate-row{display:grid;grid-template-columns:1fr auto;gap:16px;align-items:center;border-top:1px solid #e8ece9;padding:12px 0}.bat-hotel-rate-row:first-of-type{margin-top:10px}.bat-hotel-rate-price{font-weight:800;white-space:nowrap}.bat-hotel-no-rates{padding:18px;border-radius:14px;background:#f3f6f4;color:#40514c;line-height:1.55}.bat-hbx-view-details{margin-top:14px;width:100%;min-height:46px;border:1px solid #24473e;border-radius:12px;background:#24473e;color:#fff;font-weight:700;cursor:pointer}.bat-hbx-view-details:hover{filter:brightness(1.06)}.bat-hbx-card-clickable{cursor:pointer;transition:transform .16s ease,box-shadow .16s ease}.bat-hbx-card-clickable:hover{transform:translateY(-2px);box-shadow:0 16px 40px rgba(25,48,41,.12)}@media(max-width:640px){.bat-hotel-dialog-card{padding:18px}.bat-hotel-rate-row{grid-template-columns:1fr}.bat-hotel-rate-price{white-space:normal}}';
        document.head.appendChild(style);
      }
      hotelDialog=el('dialog','bat-hotel-dialog');
      hotelDialog.setAttribute('aria-label','Hotel and room details');
      hotelDialog.addEventListener('click',e=>{if(e.target===hotelDialog){if(typeof hotelDialog.close==='function')hotelDialog.close();else hotelDialog.removeAttribute('open')}});
      document.body.appendChild(hotelDialog);
      return hotelDialog;
    }
    const firstText=(...values)=>values.find(v=>typeof v==='string'&&v.trim())||'';
    const staticDetailCache=new Map();
    const LIVE_CACHE_TTL_MS=60*60*1000;
    const liveCacheKey=()=>['bat-hbx-live-v2',destinationCode?.value||'',checkIn?.value||'',checkOut?.value||'',adults?.value||''].join('|');
    function saveLiveSearch(data,contentData){
      if(!Array.isArray(data?.hotels)||!data.hotels.length)return;
      try{localStorage.setItem(liveCacheKey(),JSON.stringify({savedAt:Date.now(),data,contentData}))}catch{}
    }
    function loadLiveSearch(){
      try{
        const key=liveCacheKey(),raw=localStorage.getItem(key);
        if(!raw)return null;
        const cached=JSON.parse(raw),savedAt=Number(cached?.savedAt||0);
        if(!savedAt||Date.now()-savedAt>LIVE_CACHE_TTL_MS){localStorage.removeItem(key);return null}
        if(!Array.isArray(cached?.data?.hotels)||!cached.data.hotels.length)return null;
        return cached;
      }catch{return null}
    }
    const roomTypeLabels={SGL:'Single room',DBL:'Double room',DBT:'Double / twin room',TWN:'Twin room',TPL:'Triple room',QUA:'Quad room',QUD:'Quad room',FAM:'Family room',SUI:'Suite',JSU:'Junior suite',APT:'Apartment',STU:'Studio',VIL:'Villa'};
    const roomLabel=(roomCode,roomType,typeDescription,characteristicDescription)=>{
      if(firstText(typeDescription,characteristicDescription))return [firstText(typeDescription),firstText(characteristicDescription)].filter(Boolean).join(' · ');
      const family=String(roomType||roomCode||'').split('.')[0].toUpperCase();
      return roomTypeLabels[family]||('Room '+(roomCode||family||'type'));
    };
    const normalizeRoomText=v=>String(v||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim();
    const roomFamily=v=>String(v||'').split('.')[0].toUpperCase();
    const roomKeywords=['single','double','twin','deluxe','executive','suite','junior','family','king','queen','triple','quad','apartment','studio','villa','standard','superior','premium','club'];
    function roomImagesFor(room,content){
      const images=Array.isArray(content?.roomImages)?content.roomImages.filter(x=>x?.url):[];
      // Never substitute hotel/exterior photography for a room option.
      if(!images.length)return {images:[],fallback:false,unavailable:true};
      const code=String(room?.code||room?.roomCode||'');
      const family=roomFamily(code||room?.roomType||room?.typeCode);
      const roomText=normalizeRoomText([room?.name,room?.typeDescription,room?.characteristicDescription,room?.description,room?.bedTypeDescription,code].filter(Boolean).join(' '));
      const exact=images.filter(img=>String(img.roomCode||'')===code);
      if(exact.length)return {images:exact.slice(0,5),fallback:false,unavailable:false};
      const codePrefix=normalizeRoomText(code.split('-')[0].replace(/[.]/g,' '));
      const nearCode=images.filter(img=>{
        const imgCode=normalizeRoomText(String(img.roomCode||'').split('-')[0].replace(/[.]/g,' '));
        return codePrefix&&imgCode&&(imgCode===codePrefix||imgCode.includes(codePrefix)||codePrefix.includes(imgCode));
      });
      if(nearCode.length)return {images:nearCode.slice(0,5),fallback:false,unavailable:false};
      const familyMatches=images.filter(img=>family&&roomFamily(img.roomType||img.roomCode)===family);
      if(familyMatches.length)return {images:familyMatches.slice(0,5),fallback:false,unavailable:false};
      const wanted=roomKeywords.filter(k=>roomText.includes(k));
      if(wanted.length){
        const scored=images.map(img=>{
          const imgText=normalizeRoomText([img.description,img.roomDescription,img.roomName,img.typeDescription,img.characteristicDescription,img.roomType,img.roomCode,img.typeCode].filter(Boolean).join(' '));
          return {img,score:wanted.reduce((n,k)=>n+(imgText.includes(k)?1:0),0)};
        }).filter(x=>x.score>0).sort((a,b)=>b.score-a.score);
        if(scored.length)return {images:scored.slice(0,5).map(x=>x.img),fallback:false,unavailable:false};
      }
      return {images:[],fallback:false,unavailable:true};
    }
    function staticRoomsFromContent(content){
      const images=Array.isArray(content?.roomImages)?content.roomImages.filter(x=>x?.url):[];
      const contentRooms=Array.isArray(content?.rooms)?content.rooms:[];
      if(contentRooms.length){
        return contentRooms.map(room=>{
          const code=room.code||room.roomCode||'';
          const imageMatch=roomImagesFor({...room,code},content);
          const roomImages=imageMatch.images;
          return {
            code,
            name:roomLabel(code,room.typeCode,room.typeDescription,room.characteristicDescription),
            description:room.description||'',
            minPax:room.minPax,
            maxPax:room.maxPax,
            minAdults:room.minAdults,
            maxAdults:room.maxAdults,
            maxChildren:room.maxChildren,
            images:roomImages.slice(0,5),
            imageFallback:imageMatch.fallback,
            rates:[],
            staticOnly:true
          };
        });
      }
      const seen=new Map();
      images.forEach(img=>{
        const code=img.roomCode||img.roomType||'';
        if(!code||seen.has(code))return;
        seen.set(code,{
          code,
          name:roomLabel(code,img.roomType,'',''),
          description:'',
          images:images.filter(x=>x.roomCode===img.roomCode||(img.roomType&&x.roomType===img.roomType)).slice(0,5),
          rates:[],
          staticOnly:true
        });
      });
      return [...seen.values()];
    }
    function openHotelDetails(hotel,content,rooms,isLive,staticContent=false){
      const dlg=ensureHotelDialog();dlg.textContent='';
      const shell=el('div','bat-hotel-dialog-card');
      const top=el('div','bat-hotel-dialog-top'),head=el('div');
      const name=hotel?.name||content?.name||('Hotel '+(hotel?.code||content?.code||''));
      head.appendChild(el('h2','bat-hotel-dialog-title',name));
      const context=[checkIn?.value&&checkOut?.value?(checkIn.value+' → '+checkOut.value):'',adults?.value?(adults.value+' guest'+(adults.value==='1'?'':'s')):''].filter(Boolean).join(' · ');
      if(context)head.appendChild(el('div','bat-hotel-dialog-context',context));
      const meta=[hotel?.categoryName||content?.categoryName||'',hotel?.destinationName||content?.destinationName||content?.destinationCode||'',hotel?.zoneName||'',content?.countryCode||''].filter(Boolean).join(' · ');
      if(meta)head.appendChild(el('div','bat-hotel-dialog-meta',meta));
      const close=el('button','bat-hotel-dialog-close','×');close.type='button';close.setAttribute('aria-label','Close hotel details');close.addEventListener('click',()=>{if(typeof dlg.close==='function')dlg.close();else dlg.removeAttribute('open')});
      top.append(head,close);shell.appendChild(top);
      const hotelImages=Array.isArray(content?.hotelImages)?content.hotelImages.filter(x=>x?.url):[];
      const hero=content?.heroImageUrl||(hotelImages[0]&&(hotelImages[0].xlUrl||hotelImages[0].url))||'';
      if(hero)addImage(shell,hero,name+' photo','bat-hotel-dialog-hero',(hotelImages[0]&&hotelImages[0].url)||'');
      const address=firstText(content?.address,hotel?.address);
      if(address)shell.appendChild(el('div','bat-hotel-dialog-meta',address));
      const description=firstText(content?.description,hotel?.description);
      if(description)shell.appendChild(el('p','bat-hotel-dialog-description',description));
      const roomHead=el('div','bat-hotel-room-count');
      roomHead.appendChild(el('h3','',isLive?'Rooms & rates':'Room types'));
      if(Array.isArray(rooms)&&rooms.length)roomHead.appendChild(el('span','bat-hotel-dialog-meta',rooms.length+' room type'+(rooms.length===1?'':'s')+(staticContent?' in hotel content':' returned')));
      shell.appendChild(roomHead);
      if((isLive||staticContent)&&Array.isArray(rooms)&&rooms.length){
        rooms.forEach(room=>{
          const box=el('section','bat-hotel-room-card');
          box.appendChild(el('h4','',room.name||room.code||'Room'));
          if(room.code)box.appendChild(el('div','bat-hotel-dialog-meta','Room code: '+room.code));
          let roomImages=Array.isArray(room.images)?room.images.filter(x=>x?.url):[];
          let roomFallback=!!room.imageFallback;
          if(!roomImages.length){const match=roomImagesFor(room,content);roomImages=match.images;roomFallback=match.fallback}
          if(roomImages.length){
            const strip=el('div','bat-hbx-room-media bat-hbx-room-media-dialog');
            roomImages.slice(0,5).forEach((img,i)=>addImage(strip,img.xlUrl||img.url,(room.name||'Room')+' photo '+(i+1),'',img.url));
            box.appendChild(strip);
            if(roomFallback)box.appendChild(el('div','bat-hbx-room-photo-note','Room-specific photo unavailable from HBX.'));
          }else{
            box.appendChild(el('div','bat-hbx-room-photo-note','HBX did not supply a room-specific photo for this room type.'));
          }
          const bed=firstText(room.bedTypeDescription,room.bedType,room.beds,room.description);
          if(bed)box.appendChild(el('div','bat-hotel-dialog-meta','Room details: '+bed));
          const occupancy=[];
          const minPax=Number(room.minPax),maxPax=Number(room.maxPax);
          if(Number.isFinite(minPax)&&minPax>0)occupancy.push('min '+minPax+' guest'+(minPax===1?'':'s'));
          if(Number.isFinite(maxPax)&&maxPax>0)occupancy.push('max '+maxPax+' guest'+(maxPax===1?'':'s'));
          if(occupancy.length)box.appendChild(el('div','bat-hotel-dialog-meta','Occupancy: '+occupancy.join(' · ')));
          const rates=Array.isArray(room.rates)?room.rates:[];
          const displayRates=customerRates(rates);
          if(!displayRates.length){
            box.appendChild(el('div','bat-hotel-no-rates',staticContent?'Room type information is available. Live price and booking availability are temporarily unavailable from HBX.':'No selectable rate was returned for this room type.'));
          }else{
            displayRates.forEach(rate=>{
              const row=el('div','bat-hotel-rate-row'),copy=el('div','bat-hotel-rate-copy');
              const info=rateInfo(rate,hotel?.currency||'EUR');
              copy.appendChild(el('strong','bat-hotel-rate-board',info.board));
              copy.appendChild(el('div','bat-hotel-rate-facts',[info.cancellation,info.occupancy].filter(Boolean).join(' · ')));
              if(info.policyNote)copy.appendChild(el('div','bat-hotel-rate-policy',info.policyNote));
              const raw=rate.net||rate.sellingRate;
              const action=el('div','bat-hotel-rate-actions');
              const priceWrap=el('div','bat-hotel-rate-price-wrap');
              priceWrap.appendChild(el('strong','bat-hotel-rate-price',raw?money(raw,hotel?.currency||'EUR'):'Rate available'));
              priceWrap.appendChild(el('small','bat-hotel-rate-total-label','Total for stay'));
              action.appendChild(priceWrap);
              const select=el('button','bat-hotel-select-room','Select room');
              select.type='button';
              select.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();if(typeof dlg.close==='function')dlg.close();emitRoomSelected(root,hotel,room,rate,hotel?.currency||'EUR',content,checkIn,checkOut,adults,base,status)});
              action.appendChild(select);
              row.append(copy,action);
              box.appendChild(row);
            });
          }
          shell.appendChild(box);
        });
      }else{
        shell.appendChild(el('div','bat-hotel-no-rates','No room-type detail is stored for this hotel yet. Live prices and booking availability will appear when HBX Availability is available.'));
      }
      dlg.appendChild(shell);
      if(typeof dlg.showModal==='function')dlg.showModal();else dlg.setAttribute('open','');
    }
    async function openCachedHotelDetails(hotel,btn){
      const code=hotel?.code;
      if(!code){openHotelDetails(hotel,hotel,[],false,false);return}
      const old=btn?.textContent||'View room types →';
      if(btn){btn.disabled=true;btn.textContent='Loading room types…'}
      try{
        let content=staticDetailCache.get(String(code));
        if(!content){
          const res=await fetch(base+'/_api/hbx/content-details?codes='+encodeURIComponent(code),{headers:{Accept:'application/json'}});
          const data=await res.json();
          if(!res.ok||!data?.ok)throw new Error(data?.message||'Hotel details unavailable');
          content=Array.isArray(data.hotels)&&data.hotels[0]?data.hotels[0]:hotel;
          staticDetailCache.set(String(code),content);
        }
        const staticRooms=staticRoomsFromContent(content);
        openHotelDetails(hotel,content,staticRooms,false,true);
      }catch{
        openHotelDetails(hotel,hotel,[],false,false);
      }finally{
        if(btn){btn.disabled=false;btn.textContent=old}
      }
    }
    function addDetailsAction(card,hotel,content,rooms,isLive){
      card.classList.add('bat-hbx-card-clickable');
      if(isLive){
        const open=()=>openHotelDetails(hotel,content,rooms,true,false);
        card.addEventListener('click',e=>{if(e.target.closest('button,a,input,select,summary,details'))return;open()});
        const btn=el('button','bat-hbx-view-details','View rooms & details →');btn.type='button';btn.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();open()});card.appendChild(btn);
      }else{
        let btn=null;
        const open=()=>openCachedHotelDetails(hotel,btn);
        card.addEventListener('click',e=>{if(e.target.closest('button,a,input,select,summary,details'))return;open()});
        btn=el('button','bat-hbx-view-details','View room types →');btn.type='button';btn.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();open()});card.appendChild(btn);
      }
    }

    const now=new Date(),start=new Date(now.getFullYear(),now.getMonth(),now.getDate()+3),end=new Date(now.getFullYear(),now.getMonth(),now.getDate()+4);
    checkIn.min=iso(new Date(now.getFullYear(),now.getMonth(),now.getDate()+1));checkIn.value=iso(start);
    checkOut.min=iso(new Date(start.getFullYear(),start.getMonth(),start.getDate()+1));checkOut.value=iso(end);
    checkIn.addEventListener('change',()=>{const d=new Date(checkIn.value+'T00:00:00'),n=new Date(d.getFullYear(),d.getMonth(),d.getDate()+1);checkOut.min=iso(n);if(!checkOut.value||checkOut.value<=checkIn.value)checkOut.value=iso(n)});

    let timer=null,seq=0,items=[],active=-1;
    const hide=()=>{suggestions.hidden=true;suggestions.textContent='';items=[];active=-1;destinationInput.setAttribute('aria-expanded','false')};
    const choose=item=>{destinationInput.value=item.label||[item.name,item.countryName].filter(Boolean).join(', ');destinationCode.value=item.code||'';hide();status.textContent='Destination selected: '+destinationInput.value+'. Choose dates and search.'};
    const draw=list=>{
      suggestions.textContent='';items=list||[];active=-1;
      if(!items.length){const e=el('div','bat-hbx-suggestion','No matching destination found.');suggestions.appendChild(e);suggestions.hidden=false;destinationInput.setAttribute('aria-expanded','true');return}
      items.forEach((item,index)=>{const b=el('button','bat-hbx-suggestion');b.type='button';b.setAttribute('role','option');b.dataset.index=index;const copy=el('span');copy.appendChild(el('strong','',item.name||item.label||'Destination'));copy.appendChild(el('small','',item.countryName||item.countryCode||''));b.append(copy,el('span','bat-hbx-suggestion-code',item.code||''));b.addEventListener('mousedown',e=>{e.preventDefault();choose(item)});suggestions.appendChild(b)});
      suggestions.hidden=false;destinationInput.setAttribute('aria-expanded','true');
    };
    const find=async q=>{
      q=(q||'').trim();if(q.length<2){hide();return[]}
      const id=++seq;
      try{const r=await fetch(base+'/_api/hbx/destination-search?q='+encodeURIComponent(q),{headers:{Accept:'application/json'}});const d=await r.json();if(id!==seq)return[];const found=d?.ok&&Array.isArray(d.results)?d.results:[];draw(found);return found}catch{if(id===seq)hide();return[]}
    };
    destinationInput.addEventListener('input',()=>{destinationCode.value='';clearTimeout(timer);timer=setTimeout(()=>find(destinationInput.value),220)});
    destinationInput.addEventListener('focus',()=>{if(destinationInput.value.trim().length>=2&&!destinationCode.value)find(destinationInput.value)});
    destinationInput.addEventListener('blur',()=>setTimeout(hide,180));
    destinationInput.addEventListener('keydown',e=>{
      if(suggestions.hidden||!items.length)return;
      const buttons=[...suggestions.querySelectorAll('.bat-hbx-suggestion')];
      if(e.key==='ArrowDown'){e.preventDefault();active=Math.min(active+1,items.length-1)}
      else if(e.key==='ArrowUp'){e.preventDefault();active=Math.max(active-1,0)}
      else if(e.key==='Enter'&&active>=0){e.preventDefault();choose(items[active]);return}
      else if(e.key==='Escape'){hide();return}else return;
      buttons.forEach((b,i)=>b.setAttribute('aria-selected',i===active?'true':'false'));buttons[active]?.scrollIntoView({block:'nearest'});
    });

    function waitForLeaflet(){
      if(window.L)return Promise.resolve(window.L);
      return new Promise(resolve=>{let tries=0;const t=setInterval(()=>{tries++;if(window.L||tries>80){clearInterval(t);resolve(window.L||null)}},100)});
    }
    async function drawMapFromCards(cards){
      if(!mapEl)return;
      const L=await waitForLeaflet();if(!L)return;
      if(!leafletMap){
        leafletMap=L.map(mapEl,{zoomControl:true,scrollWheelZoom:true});
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:19,attribution:'© OpenStreetMap'}).addTo(leafletMap);
        markerLayer=L.layerGroup().addTo(leafletMap);
      }
      markerLayer.clearLayers();
      const points=[];
      (cards||[]).filter(c=>!c.hidden).forEach(card=>{
        const lat=Number(card.dataset.lat),lng=Number(card.dataset.lng);
        if(!Number.isFinite(lat)||!Number.isFinite(lng))return;
        const hasLiveRate=card.dataset.hasLiveRate==='1';
        const price=hasLiveRate?money(card.dataset.price,card.dataset.currency||'EUR'):'View hotel';
        const icon=L.divIcon({className:'',html:'<div class="bat-price-pin">'+price.replace(/&/g,'&amp;').replace(/</g,'&lt;')+'</div>',iconSize:null,iconAnchor:[24,16]});
        const marker=L.marker([lat,lng],{icon}).addTo(markerLayer);
        const name=card.dataset.hotelName||'Hotel';
        const popupSub=hasLiveRate?price:'Saved BookATrip hotel';
        marker.bindPopup('<div class="bat-map-popup"><strong>'+name.replace(/&/g,'&amp;').replace(/</g,'&lt;')+'</strong><span>'+popupSub.replace(/&/g,'&amp;').replace(/</g,'&lt;')+'</span></div>');
        marker.on('click',()=>{card.scrollIntoView({behavior:'smooth',block:'center'});card.animate([{transform:'scale(1)'},{transform:'scale(1.012)'},{transform:'scale(1)'}],{duration:450})});
        points.push([lat,lng]);
      });
      if(points.length===1)leafletMap.setView(points[0],14);
      else if(points.length>1)leafletMap.fitBounds(points,{padding:[28,28],maxZoom:14});
      else leafletMap.setView([25.2048,55.2708],11);
      setTimeout(()=>leafletMap.invalidateSize(),80);
    }
    function renderCachedCatalog(data,contentData={hotels:[]}){
      results.textContent='';
      root.dataset.dataMode='catalog';
      const contentMap=new Map((contentData?.hotels||[]).map(h=>[Number(h.code),h]));
      const list=Array.isArray(data?.hotels)?data.hotels:[];
      if(!list.length){
        if(resultsShell)resultsShell.hidden=true;
        results.hidden=true;
        return;
      }
      list.forEach(hotel=>{
        const content=contentMap.get(Number(hotel.code))||hotel;
        const staticRooms=staticRoomsFromContent(content);
        const card=el('article','bat-hbx-card');
        const starMatch=String(hotel.categoryCode||'').match(/[1-5]/);
        const stars=starMatch?Number(starMatch[0]):0;
        card.dataset.stars=String(stars||0);
        card.dataset.price='';
        card.dataset.breakfast='0';
        card.dataset.flexible='0';
        card.dataset.hasLiveRate='0';
        card.dataset.hotelName=hotel.name||('Hotel '+hotel.code);
        card.dataset.currency='EUR';
        const lat=Number(hotel.latitude),lng=Number(hotel.longitude);
        if(Number.isFinite(lat)&&Number.isFinite(lng)){card.dataset.lat=String(lat);card.dataset.lng=String(lng)}
        const fallbackPhotos=Array.isArray(content?.hotelImages)?content.hotelImages.filter(x=>x?.url):[];
        const hero=content?.heroImageUrl||hotel.heroImageUrl||(fallbackPhotos[0]&&(fallbackPhotos[0].xlUrl||fallbackPhotos[0].url))||'';
        if(hero){
          const g=el('div','bat-hbx-gallery');
          addImage(g,hero,(hotel.name||content?.name||'Hotel')+' photo','bat-hbx-hero-photo',(fallbackPhotos[0]&&fallbackPhotos[0].url)||'');
          card.appendChild(g);
          card.appendChild(el('div','bat-hbx-photo-count',(fallbackPhotos.length||1)+' hotel photo'+((fallbackPhotos.length||1)===1?'':'s')+' available'));
        }
        const head=el('div','bat-hbx-card-head'),title=el('div');
        title.appendChild(el('h3','',hotel.name||('Hotel '+hotel.code)));
        const meta=[stars?stars+' stars':'',hotel.destinationCode||'',hotel.countryCode||''].filter(Boolean).join(' · ');
        if(meta)title.appendChild(el('div','bat-hbx-meta',meta));
        if(hotel.address)title.appendChild(el('div','bat-hbx-meta',hotel.address));
        const availability=el('div','bat-hbx-price','live rate');
        availability.appendChild(el('strong','','Check later'));
        head.append(title,availability);
        card.appendChild(head);
        if(content?.description||hotel.description)card.appendChild(el('p','bat-hbx-description',content?.description||hotel.description));
        if(staticRooms.length){
          staticRooms.slice(0,6).forEach(room=>{
            const row=el('div','bat-hbx-room');
            const summary=el('div','bat-hbx-room-summary');
            const match=roomImagesFor(room,content);
            const preview=(Array.isArray(room.images)&&room.images[0])||(match.images&&match.images[0])||null;
            if(preview){
              const thumbWrap=el('span','bat-hbx-room-thumb');
              addImage(thumbWrap,preview.xlUrl||preview.url,(room.name||'Room')+' photo','',preview.url);
              summary.appendChild(thumbWrap);
            }else{
              summary.appendChild(el('span','bat-hbx-room-thumb bat-hbx-room-thumb-empty','Room photo unavailable'));
            }
            const copy=el('span','bat-hbx-room-summary-copy');
            copy.appendChild(el('strong','',room.name||room.code||'Room'));
            copy.appendChild(el('small','bat-hbx-room-photo-note','Live price temporarily unavailable'));
            summary.appendChild(copy);
            row.appendChild(summary);
            card.appendChild(row);
          });
        }
        const note=el('div','bat-hbx-meta','Hotel and room types remain visible while HBX live prices refresh.');
        card.appendChild(note);
        addDetailsAction(card,hotel,content,staticRooms,false);
        results.appendChild(card);
      });
      results.hidden=false;
      if(resultsShell)resultsShell.hidden=false;
      if(resultTitle)resultTitle.textContent=(data.total||list.length)+' saved stays · showing '+list.length;
      root.dispatchEvent(new CustomEvent('bat:hbx-results-ready',{detail:{count:list.length,mode:'catalog'}}));
      drawMapFromCards([...results.querySelectorAll('.bat-hbx-card')]);
    }

    async function loadCachedCatalog(){
      const cr=await fetch(base+'/_api/hbx/catalog-search?destinationCode='+encodeURIComponent(destinationCode.value)+'&limit=100',{headers:{Accept:'application/json'}});
      const cd=await cr.json();
      if(!cr.ok||!cd?.ok)throw new Error(cd?.message||'Saved hotel catalog search failed');
      return cd;
    }

    function render(data,contentData,options={}){
      results.textContent='';
      root.dataset.dataMode=options.cached?'cached-live':'live';
      const contentMap=new Map((contentData?.hotels||[]).map(h=>[Number(h.code),h]));
      const list=Array.isArray(data.hotels)?data.hotels:[];
      if(!list.length){results.appendChild(el('div','bat-hbx-card','No available test rates were returned for those dates.'));results.hidden=false;return}
      list.forEach(hotel=>{
        const content=contentMap.get(Number(hotel.code))||{},card=el('article','bat-hbx-card');
        const hotelRooms=Array.isArray(hotel.rooms)?hotel.rooms:[];
        const displayRooms=hotelRooms.map(room=>{const apiImages=Array.isArray(room?.images)?room.images.filter(x=>x&&(x.url||x.xlUrl)):[];if(apiImages.length)return {...room,images:apiImages,imageFallback:room?.imageMatch==='room-fallback',roomPhotoUnavailable:false};if(room?.imageUrl){const direct={url:room.imageUrl,xlUrl:room.imageUrl,roomCode:room?.code||null};return {...room,images:[direct],imageFallback:room?.imageMatch==='room-fallback',roomPhotoUnavailable:false}}const match=roomImagesFor(room,content);return {...room,images:match.images,imageFallback:match.fallback,roomPhotoUnavailable:match.unavailable}});
        const allRates=hotelRooms.flatMap(room=>Array.isArray(room.rates)?room.rates:[]);
        const starMatch=String(hotel.categoryCode||hotel.categoryName||'').match(/[1-5]/);
        card.dataset.stars=starMatch?starMatch[0]:'0';
        card.dataset.price=String(Number(hotel.minRate)||0);
        card.dataset.breakfast=allRates.some(rate=>/breakfast|half board|full board|all inclusive/i.test(String(rate.boardName||'')+' '+String(rate.boardCode||'')))?'1':'0';
        card.dataset.flexible=allRates.some(rate=>String(rate.rateClass||'').toUpperCase()!=='NRF')?'1':'0';
        const lat=Number(content.latitude??content.coordinates?.latitude??content.coordinates?.lat??hotel.latitude);
        const lng=Number(content.longitude??content.coordinates?.longitude??content.coordinates?.lng??hotel.longitude);
        if(Number.isFinite(lat)&&Number.isFinite(lng)){card.dataset.lat=String(lat);card.dataset.lng=String(lng)}
        card.dataset.hotelName=hotel.name||content.name||('Hotel '+hotel.code);
        card.dataset.currency=hotel.currency||'EUR';
        card.dataset.hasLiveRate='1';
        const photos=Array.isArray(content.hotelImages)?content.hotelImages.filter(x=>x?.url).slice(0,5):[];
        if(photos.length){const g=el('div','bat-hbx-gallery');photos.slice(0,3).forEach((p,i)=>addImage(g,p.xlUrl||p.url,(hotel.name||'Hotel')+' photo '+(i+1),i===0?'bat-hbx-hero-photo':'',p.url));card.appendChild(g);card.appendChild(el('div','bat-hbx-photo-count',photos.length+' hotel photos available'))}
        const head=el('div','bat-hbx-card-head'),title=el('div');title.appendChild(el('h3','',hotel.name||content.name||('Hotel '+hotel.code)));title.appendChild(el('div','bat-hbx-meta',[(hotel.categoryName||''),(hotel.destinationName||''),(hotel.zoneName||'')].filter(Boolean).join(' · ')));if(content.address)title.appendChild(el('div','bat-hbx-meta',content.address));const price=el('div','bat-hbx-price','from');price.appendChild(el('strong','',money(hotel.minRate,hotel.currency)));head.append(title,price);card.appendChild(head);if(content.description)card.appendChild(el('p','bat-hbx-description',content.description));
        const allRoomImages=Array.isArray(content.roomImages)?content.roomImages:[];
        displayRooms.forEach((room,roomIndex)=>{
          const details=el('details','bat-hbx-room');
          if(roomIndex===0)details.open=true;
          const summary=el('summary','bat-hbx-room-summary');
          const preview=Array.isArray(room.images)&&room.images.length?room.images[0]:null;
          if(preview){
            const thumbWrap=el('span','bat-hbx-room-thumb');
            addImage(thumbWrap,preview.xlUrl||preview.url,(room.name||'Room')+' photo','',preview.url);
            summary.appendChild(thumbWrap);
          }else{
            summary.appendChild(el('span','bat-hbx-room-thumb bat-hbx-room-thumb-empty','Room photo unavailable'));
          }
          const summaryCopy=el('span','bat-hbx-room-summary-copy');
          summaryCopy.appendChild(el('strong','',room.name||room.code||'Room'));
          if(!preview)summaryCopy.appendChild(el('small','bat-hbx-room-photo-note','Room photo not supplied by HBX'));
          summary.appendChild(summaryCopy);
          const rates=Array.isArray(room.rates)?room.rates:[];
          const displayRates=customerRates(rates);
          if(displayRates[0])summary.appendChild(el('span','bat-hbx-room-summary-price',money(displayRates[0].net||displayRates[0].sellingRate,hotel.currency)));
          details.appendChild(summary);
          if(Array.isArray(room.images)&&room.images.length){
            const strip=el('div','bat-hbx-room-media');
            room.images.slice(0,5).forEach((x,j)=>addImage(strip,x.xlUrl||x.url,(room.name||'Room')+' photo '+(j+1),'',x.url));
            details.appendChild(strip);
          }else{
            details.appendChild(el('div','bat-hbx-room-photo-note','HBX did not supply a room-specific photo for this room type.'));
          }
          displayRates.forEach(rate=>{
            const row=el('div','bat-hbx-rate bat-hbx-rate-detailed'),copy=el('div','bat-hbx-rate-copy');
            const info=rateInfo(rate,hotel.currency);
            copy.appendChild(el('strong','bat-hbx-rate-board',info.board));
            copy.appendChild(el('div','bat-hbx-rate-facts',[info.cancellation,info.occupancy].filter(Boolean).join(' · ')));
            if(info.policyNote)copy.appendChild(el('div','bat-hbx-rate-policy',info.policyNote));
            const action=el('div','bat-hbx-rate-action');
            const priceWrap=el('div','bat-hbx-rate-price-wrap');
            priceWrap.appendChild(el('strong','bat-hbx-rate-total',money(rate.net||rate.sellingRate,hotel.currency)));
            priceWrap.appendChild(el('small','bat-hbx-rate-total-label','Total for stay'));
            const btn=el('button','bat-hbx-rate-select','Select');
            btn.type='button';
            btn.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();emitRoomSelected(root,hotel,room,rate,hotel.currency,content,checkIn,checkOut,adults,base,status)});
            action.append(priceWrap,btn);
            row.append(copy,action);
            details.appendChild(row);
          });
          card.appendChild(details);
        });
        addDetailsAction(card,hotel,content,displayRooms,true);
        results.appendChild(card);
      });
      results.hidden=false;
      if(resultsShell)resultsShell.hidden=false;
      if(resultTitle)resultTitle.textContent=(data.total||list.length)+' stays found'+(options.cached?' · recently checked':'');
      root.dispatchEvent(new CustomEvent('bat:hbx-results-ready',{detail:{count:list.length,mode:options.cached?'cached-live':'live'}}));
      drawMapFromCards([...results.querySelectorAll('.bat-hbx-card')]);
    }

    root.addEventListener('bat:hbx-filtered',()=>drawMapFromCards([...results.querySelectorAll('.bat-hbx-card')]));
    form.addEventListener('submit',async e=>{
      e.preventDefault();results.hidden=true;if(resultsShell)resultsShell.hidden=true;const submit=form.querySelector('button[type="submit"]');submit.disabled=true;
      try{
        if(!destinationCode.value){status.textContent='Finding destination…';const found=await find(destinationInput.value);if(!found.length)throw new Error('Choose a destination from the suggestions.');choose(found[0])}
        status.textContent='Searching hotels in '+destinationInput.value+' and loading photos…';
        const qs=new URLSearchParams({checkIn:checkIn.value,checkOut:checkOut.value,adults:adults.value,destinationCode:destinationCode.value});
        const availabilityRes=await fetch(base+'/_api/hbx/availability?'+qs.toString(),{headers:{Accept:'application/json'}});
        const data=await availabilityRes.json();
        if(availabilityRes.ok&&data?.ok){
          const codes=(Array.isArray(data.hotels)?data.hotels:[]).map(h=>h.code).filter(Boolean).slice(0,50).join(',');
          let contentData={hotels:[]};
          if(codes){try{const cr=await fetch(base+'/_api/hbx/content-details?codes='+encodeURIComponent(codes),{headers:{Accept:'application/json'}}),cd=await cr.json();if(cr.ok&&cd?.ok)contentData=cd}catch{}}
          const shown=Array.isArray(data.hotels)?data.hotels.length:0;
          status.textContent=(data.total||shown)+' hotels found in '+destinationInput.value+' · showing '+shown+' live test results with room rates and available photos.';
          saveLiveSearch(data,contentData);
          render(data,contentData);
        }else{
          const recent=loadLiveSearch();
          if(recent){
            status.textContent='HBX live refresh is temporarily unavailable. Showing recently retrieved room options; final price will be rechecked when you select a room.';
            render(recent.data,recent.contentData||{hotels:[]},{cached:true});
          }else{
            status.textContent='Live HBX rates are temporarily unavailable. Loading hotel photos and room types…';
            const cached=await loadCachedCatalog();
            const codes=(Array.isArray(cached?.hotels)?cached.hotels:[]).map(h=>h.code).filter(Boolean).slice(0,50).join(',');
            let fallbackContent={hotels:[]};
            if(codes){try{const cr=await fetch(base+'/_api/hbx/content-details?codes='+encodeURIComponent(codes),{headers:{Accept:'application/json'}}),cd=await cr.json();if(cr.ok&&cd?.ok)fallbackContent=cd}catch{}}
            if(Array.isArray(cached?.hotels)&&cached.hotels.length){
              status.textContent=(cached.total||cached.hotels.length)+' saved hotels found in '+destinationInput.value+' · hotel photos and room types are shown while live prices refresh.';
              renderCachedCatalog(cached,fallbackContent);
            }else{
              throw new Error('No saved hotels are available for this destination yet.');
            }
          }
        }
      }catch(err){
        const recent=loadLiveSearch();
        if(recent){
          status.textContent='Connection interrupted. Showing recently retrieved room options; price will be rechecked before booking.';
          render(recent.data,recent.contentData||{hotels:[]},{cached:true});
        }else{
          try{
            const cached=await loadCachedCatalog();
            const codes=(Array.isArray(cached?.hotels)?cached.hotels:[]).map(h=>h.code).filter(Boolean).slice(0,50).join(',');
            let fallbackContent={hotels:[]};
            if(codes){try{const cr=await fetch(base+'/_api/hbx/content-details?codes='+encodeURIComponent(codes),{headers:{Accept:'application/json'}}),cd=await cr.json();if(cr.ok&&cd?.ok)fallbackContent=cd}catch{}}
            if(Array.isArray(cached?.hotels)&&cached.hotels.length){
              status.textContent='Live prices are temporarily unavailable. Hotel photos and room types remain visible.';
              renderCachedCatalog(cached,fallbackContent);
            }else throw err;
          }catch{
            status.textContent='Search could not be completed: '+(err&&err.message?err.message:'Unknown error');
            results.hidden=true;if(resultsShell)resultsShell.hidden=true
          }
        }
      }
      finally{submit.disabled=false}
    });
  });
})();